<template>
  <div id="breadcrumbs" :style="{left:leftNum+'px'}">
    当前位置：<span class="path">{{meta.bt}}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
  export default {
    props: ['left'],
    data() {
      return {
      }
    },
    computed: {
      ...mapState({
        meta: state => state.breadCrunbData
      }),
      leftNum(){
        return Number(this.left) + 18
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';
#breadcrumbs {
  position: fixed;
  top: 93px;
  line-height: 22px;
  font-size: 14px;
  color: #999;
  padding-left: 18px;
  transition: .3s;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: $themeColor;
  }
  .path {
    font-size: 12px;
    color: #333;
  }
}
</style>